module.exports = __webpack_public_path__ + "img/tecnologia.26104dac.png";